export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-01_EN.45c1dceb.png";